import React from 'react';
import Card from '../../Components/Card/Card';
import CardHeader from '../../Components/Card/CardHeader';
import CardBody from '../../Components/Card/CardBody';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import { Card as Card2, CardHeader as CardHeader2, CardContent } from '@material-ui/core';
import 'jquery-confirm';

export default function Profiles(props) {
    if (!props.penalistData.hasOwnProperty('data') || props.penalistData.data === null) return <></>;
    return (
        <Card>
            <CardHeader color="info">
                <div className="d-flex align-items-center justify-content-between">
                    <h4 className="text-center">Profiles &nbsp;
                        <Chip
                            label={props.profileOverviewData.overallAttemptedPercentage + "% Completed"}
                            color="default"
                            variant="outlined"
                        />
                    </h4>
                </div>
            </CardHeader>
            <CardBody>
                <Grid container spacing={5}>
                    {
                        props.profileOverviewData?.result?.map((data, index) => (
                            <Grid item xs={12} sm={6} key={"profileOverviewData" + index}>
                                <Card2>
                                    <CardHeader2
                                        title={<>
                                            {data.name}
                                            <Chip
                                                label={parseInt(data.attemptedPercentage, 10) > 0 ? `${parseInt(data.attemptedPercentage, 10)}% Completed` : 'Not Started'}
                                                style={{ marginLeft: '8px' }} // Adjust styling as needed
                                            />
                                        </>}
                                        titleTypographyProps={{ style: { fontSize: '16px' } }}
                                        style={{ background: '#454545', color: 'white' }}
                                    />
                                    <CardContent>
                                        <img
                                            src={`https://indiapolls.com:9000${data.image}`}
                                            alt="FullSizeImage"
                                            style={{ width: '100%', height: '300px' }}
                                        />
                                    </CardContent>
                                </Card2>
                            </Grid>
                        ))
                    }
                </Grid>
            </CardBody>
        </Card>
    )
}